import React, { useState, useEffect, useRef } from "react";
import CryptoJS from "crypto-js";
import { Autocomplete, Button, CircularProgress, Stack, TextField, Box, Grid, Typography,InputAdornment } from "@mui/material";
import { toast,ToastContainer } from "react-toastify";

import axios from "axios";

const AadhaarPay = () => {
    const [loading, setLoading] = useState(false);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [amount, setAmount] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [aadhaarNumber, setAadhaarNumber] = useState("");
    const [banks, setBanks] = useState([]);
    const [discoverLoading, setDiscoverLoading] = useState(false);
    const [deviceDiscovered, setDeviceDiscovered] = useState(false);
    const [selectedBank, setSelectedBank] = useState(null);
    
    const [errors, setErrors] = useState({
        amount: "",
        mobileNumber: "",
        aadhaarNumber: "",
        bank: ""
    });
    const finalUrlRef = useRef(null);

    // Function to get the user's latitude and longitude
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    alert("Failed to get location. Please check your location settings.");
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    }, []);

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                const token = sessionStorage.getItem("jwtToken");
                if (!token) {
                    toast.error("Authentication token missing.");
                    return;
                }

                const response = await axios.get("https://api.ipaisa.co.in/myapp/auth/cms/aadharPayBankList", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                console.log("Bank List", response.data.body.data);

                setBanks(response.data.body.data);
            } catch (error) {
                console.error("Error fetching banks:", error);
                toast.error("Failed to load bank list.");
            }
        };

        fetchBanks();
    }, []);

    const validateFields = () => {
        let valid = true;
        const newErrors = {
            amount: "",
            mobileNumber: "",
            aadhaarNumber: "",
            bank: ""
        };

        if (!selectedBank) {
            newErrors.bank = "Please select a bank";
            valid = false;
        }

        if (!amount || isNaN(amount) || parseFloat(amount) < 50) {
            newErrors.amount = "Amount must be greater than 50";
            valid = false;
        }

        if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
            newErrors.mobileNumber = "Please enter a valid 10-digit mobile number";
            valid = false;
        }

        if (!aadhaarNumber || !/^\d{12}$/.test(aadhaarNumber)) {
            newErrors.aadhaarNumber = "Please enter a valid 12-digit Aadhaar number";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    // const discoverAvdm = async () => {
    //     if (!validateFields()) return;
    
    //     setDiscoverLoading(true);
    //     const toastId = toast.loading("Discovering device...");
    //     let successFlag = false;
        
    //     // First try the most common default port
    //     const defaultPort = 11105;
    //     const primaryUrl = window.location.protocol === "https:" 
    //         ? `https://127.0.0.1:${defaultPort}` 
    //         : `http://127.0.0.1:${defaultPort}`;
    
    //     try {
    //         const response = await fetch(primaryUrl, {
    //             method: "GET",
    //             mode: "cors",
    //             headers: { "Content-Type": "text/xml; charset=utf-8" },
    //         });
    
    //         if (response.ok) {
    //             const data = await response.text();
    //             if (data.includes("Mantra")) {
    //                 finalUrlRef.current = primaryUrl;
    //                 successFlag = true;
    //             }
    //         }
    //     } catch (error) {
    //         console.log("Trying fallback ports...");
    //         // Fallback to port range if default fails
    //         for (let i = 11100; i <= 11120; i++) {
    //             if (i === defaultPort) continue; // Skip already tried port
                
    //             try {
    //                 const url = window.location.protocol === "https:" 
    //                     ? `https://127.0.0.1:${i}` 
    //                     : `http://127.0.0.1:${i}`;
                        
    //                 const response = await fetch(url, {
    //                     method: "GET",
    //                     mode: "cors",
    //                     headers: { "Content-Type": "text/xml; charset=utf-8" },
    //                 });
    
    //                 if (response.ok) {
    //                     const data = await response.text();
    //                     if (data.includes("Mantra")) {
    //                         finalUrlRef.current = url;
    //                         successFlag = true;
    //                         break;
    //                     }
    //                 }
    //             } catch (err) {
    //                 console.log(`Port ${i} not available`);
    //             }
    //         }
    //     }
    
    //     setDiscoverLoading(false);
        
    //     if (successFlag) {
    //         setDeviceDiscovered(true);
    //         toast.update(toastId, {
    //             render: "Device discovered successfully!",
    //             type: "success",
    //             isLoading: false,
    //             autoClose: 3000,
    //         });
    //     } else {
    //         toast.update(toastId, {
    //             render: (
    //                 <div>
    //                     <p>Device discovery failed. Please ensure:</p>
    //                     <ol>
    //                         <li>Mantra RD Service is installed and running</li>
    //                         <li>No other application is using ports 11100-11120</li>
    //                         <li>Try restarting the RD Service</li>
    //                     </ol>
    //                 </div>
    //             ),
    //             type: "error",
    //             isLoading: false,
    //             autoClose: 8000,
    //         });
    //     }
    // };

    // const discoverAvdm = async () => {
    //     setDiscoverLoading(true);
    //     let successFlag = false;
    //     let primaryUrl = window.location.protocol === "https:" ? "https://127.0.0.1:" : "http://127.0.0.1:";

    //     for (let i = 11100; i <= 11120; i++) {
    //         try {
    //             const response = await fetch(primaryUrl + i, {
    //                 method: "RDSERVICE",
    //                 mode: "cors",
    //                 headers: { "Content-Type": "text/xml; charset=utf-8" },
    //             });

    //             if (!response.ok) continue;
    //             const data = await response.text();
    //             if (data.includes("Mantra")) {
    //                 finalUrlRef.current = primaryUrl + i;
    //                 successFlag = true;
    //                 break;
    //             }
    //         } catch (error) {
    //             console.error("Error discovering AVDM:", error);
    //         }
    //     }

    //     setDiscoverLoading(false);
    //     if (successFlag) {
    //         setDeviceDiscovered(true);
    //         toast.success("Device discovered successfully!");
    //     } else {
    //         toast.error("Device discovery failed. Please try again.");
    //     }
    // };

    const discoverAvdm = async () => {
        if (!validateFields()) return;
    
        setDiscoverLoading(true);
        const toastId = toast.loading("Discovering device...");
        let successFlag = false;
        const protocol = window.location.protocol === "https:" ? "https://" : "http://";
    
        // Try default port first (11105)
        try {
            const defaultUrl = `${protocol}127.0.0.1:11105`;
            const response = await fetch(defaultUrl, {
                method: "RDSERVICE",  // Changed from "RDSERVICE" to "GET"
                mode: "cors",
                headers: { "Content-Type": "text/xml; charset=utf-8" },
            });
    
            if (response.ok) {
                const data = await response.text();
                if (data.includes("Mantra")) {
                    finalUrlRef.current = defaultUrl;
                    successFlag = true;
                }
            }
        } catch (error) {
            console.log("Default port failed, trying others...");
        }
    
        // If default port failed, try others
        if (!successFlag) {
            for (let i = 11100; i <= 11120; i++) {
                if (i === 11105) continue; // Skip already tried port
                
                try {
                    const url = `${protocol}127.0.0.1:${i}`;
                    const response = await fetch(url, {
                        method: "RDSERVICE",  // Changed from "RDSERVICE" to "GET"
                        mode: "cors",
                        headers: { "Content-Type": "text/xml; charset=utf-8" },
                    });
    
                    if (response.ok) {
                        const data = await response.text();
                        if (data.includes("Mantra")) {
                            finalUrlRef.current = url;
                            successFlag = true;
                            break;
                        }
                    }
                } catch (error) {
                    console.log(`Port ${i} not available`);
                }
            }
        }
    
        setDiscoverLoading(false);
        
        if (successFlag) {
            setDeviceDiscovered(true);
            toast.update(toastId, {
                render: "Device discovered successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
            });
        } else {
            toast.update(toastId, {
                render: (
                    <div>
                        <p>Device discovery failed. Please ensure:</p>
                        <ol>
                            <li>Mantra RD Service is installed and running</li>
                            <li>No other application is using ports 11100-11120</li>
                            <li>Try restarting the RD Service</li>
                        </ol>
                    </div>
                ),
                type: "error",
                isLoading: false,
                autoClose: 8000,
            });
        }
    };
    const handleAadhaarPay = async (extractedData) => {
        setLoading(true);
        const token = sessionStorage.getItem("jwtToken");
        if (!token) {
            toast.error("Authentication token missing.");
            setLoading(false);
            return;
        }
    
        const payload = {
            mobileNumber: mobileNumber,
            transactionAmount: amount,
            nationalBankIdentificationNumber: selectedBank.iinno,
            adhaarNumber: aadhaarNumber,
            latitude: latitude,
            longitude: longitude,
            ...extractedData,
        };
    
        try {
            const response = await axios.post(
                "https://api.ipaisa.co.in/myapp/auth/cms/aadharPay",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            if(response.data?.statusCodeValue===200)
            {
                toast.success("Transaction successful! Amount deducted from customer's account.");
                console.log("Cash withdrawal successful:", response.data);
            }else{
                toast.warn(response.data.body?.message||"SAHIL BHOSDICHA");
            }
    
           
        } catch (error) {
            console.error("Error during cash withdrawal:", error);
            toast.error(error.response?.data?.message || "Transaction failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

      const captureAndPay = async () => {
        if (!validateFields()) return;
        
        if (!finalUrlRef.current) {
            toast.error("Please discover AVDM first.");
            return;
        }
    
        const captureUrl = `${finalUrlRef.current}/rd/capture`;
        let toastId;
    
        try {
            setLoading(true);
            toastId = toast.loading("Capturing biometric data...");
    
            const XML = `<?xml version="1.0"?>
                        <PidOptions ver="1.0">
                            <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" />
                            <CustOpts>
                                <Param name="mantrakey" value="SOME_KEY_VALUE" />
                            </CustOpts>
                        </PidOptions>`;
    
            const response = await fetch(captureUrl, {
                method: "CAPTURE",  // Changed from "CAPTURE" to "POST"
                headers: {
                    "Content-Type": "text/xml; charset=utf-8",
                },
                body: XML,
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.text();
            console.log("Capture Successful: ", data);
    
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, "text/xml");
    
            const resp = xmlDoc.getElementsByTagName('Resp')[0];
            const errInfo = resp.getAttribute("errInfo");
            
            if (errInfo !== "Success.") {
                toast.update(toastId, {
                    render: `Capture failed: ${errInfo}`,
                    type: "error",
                    isLoading: false,
                    autoClose: 5000,
                });
                return;
            }
    
            const deviceInfo = xmlDoc.getElementsByTagName('DeviceInfo')[0];
            const additionalInfo = deviceInfo.getElementsByTagName('additional_info')[0];
            const skey = xmlDoc.getElementsByTagName('Skey')[0];
            const pidDataElement = xmlDoc.getElementsByTagName('Data')[0];
    
            const skeydata = skey.textContent;
            const ci = skey.getAttribute('ci');
            const piddata = pidDataElement.textContent;
            const pidtype = pidDataElement.getAttribute('type');
    
            const parameters = [];
            const params = additionalInfo.getElementsByTagName('Param');
            for (let i = 0; i < params.length; i++) {
                parameters.push({
                    name: params[i].getAttribute('name'),
                    value: params[i].getAttribute('value')
                });
            }
    
            const extractedData = {
                resp: {
                    errCode: resp.getAttribute('errCode'),
                    errInfo: errInfo,
                    fCount: resp.getAttribute('fCount'),
                    fType: resp.getAttribute('fType'),
                    nmPoints: resp.getAttribute('nmPoints'),
                    qScore: resp.getAttribute('qScore')
                },
                deviceInfo: {
                    dpId: deviceInfo.getAttribute('dpId'),
                    rdsId: deviceInfo.getAttribute('rdsId'),
                    rdsVer: deviceInfo.getAttribute('rdsVer'),
                    mi: deviceInfo.getAttribute('mi'),
                    mc: deviceInfo.getAttribute('mc'),
                    dc: deviceInfo.getAttribute('dc')
                },
                additionalInfo: parameters,
                ci: ci,
                skeydata: skeydata,
                hmac: xmlDoc.getElementsByTagName('Hmac')[0].textContent,
                piddata: piddata,
                pidtype: pidtype
            };
    
            toast.update(toastId, {
                render: "Biometric captured successfully! Processing payment...",
                type: "info",
                isLoading: true,
                autoClose: false,
            });
    
            await handleAadhaarPay(extractedData);
    
            // Success toast will be handled in handleAadhaarPay
        } catch (error) {
            console.error("Error capturing data:", error);
            if (toastId) {
                toast.update(toastId, {
                    render: "Failed to capture data. Please try again.",
                    type: "error",
                    isLoading: false,
                    autoClose: 5000,
                });
            } else {
                toast.error("Failed to capture data. Please try again.");
            }
        } finally {
            setLoading(false);
            // Ensure any remaining loading toast is dismissed
            if (toastId) {
                toast.dismiss(toastId);
            }
        }
    };
    return (
        <Box sx={{ textAlign: "center", marginTop: "100px", padding: "20px" }}>
            <Typography sx={{ padding: '2rem' }}>Aadhaar Pay</Typography>
            <Grid container spacing={2} justifyContent="center">
                {/* Bank Selection */}
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        options={banks}
                        getOptionLabel={(option) => `${option.bankName}`}
                        onChange={(_, newValue) => {
                            setSelectedBank(newValue);
                            setErrors({ ...errors, bank: "" });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select Bank"
                                variant="outlined"
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!errors.bank}
                                helperText={errors.bank}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                <TextField
    type="number"
    value={amount}
    onChange={(e) => {
        const value = e.target.value;
        setAmount(value);
        
        // Validate on each change
        if (value && (isNaN(value) || parseFloat(value) < 50)) {
            setErrors({ ...errors, amount: "Amount must be ≥ 50" });
        } else {
            setErrors({ ...errors, amount: "" });
        }
    }}
    placeholder="Enter Amount (min ₹50)"
    fullWidth
    sx={{ 
        mb: 2,
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: errors.amount ? 'red' : '',
            },
            '&:hover fieldset': {
                borderColor: errors.amount ? 'red' : '',
            },
        }
    }}
    InputProps={{
        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
    }}
    error={!!errors.amount}
    helperText={errors.amount ? (
        <Typography variant="caption" color="error">
            {errors.amount}
        </Typography>
    ) : (
        <Typography variant="caption" color="textSecondary">
            Amount should be greater than or equal to 50
        </Typography>
    )}
/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        type="text"
                        value={mobileNumber}
                        onChange={(e) => {
                            setMobileNumber(e.target.value);
                            setErrors({ ...errors, mobileNumber: "" });
                        }}
                        placeholder="Mobile Number"
                        fullWidth
                        sx={{ mb: 2 }}
                        inputProps={{ maxLength: 10 }}
                        error={!!errors.mobileNumber}
                        helperText={errors.mobileNumber}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        type="text"
                        value={aadhaarNumber}
                        onChange={(e) => {
                            setAadhaarNumber(e.target.value);
                            setErrors({ ...errors, aadhaarNumber: "" });
                        }}
                        placeholder="Aadhaar Number"
                        fullWidth
                        sx={{ mb: 2 }}
                        inputProps={{ maxLength: 12 }}
                        error={!!errors.aadhaarNumber}
                        helperText={errors.aadhaarNumber}
                    />
                </Grid>
                
                <Grid item xs={12} md={6}>
                    <TextField
                        type="text"
                        value={latitude}
                        disabled
                        placeholder="Latitude"
                        fullWidth
                        sx={{ mb: 2, backgroundColor: "#f0f0f0" }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        type="text"
                        value={longitude}
                        disabled
                        placeholder="Longitude"
                        fullWidth
                        sx={{ mb: 2, backgroundColor: "#f0f0f0" }}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Stack spacing={2} direction="row" justifyContent="center">
                    <Button
                        variant="contained"
                        onClick={discoverAvdm}
                        disabled={discoverLoading || loading}
                        sx={{
                            padding: "10px 20px",
                            fontSize: "16px",
                            backgroundColor: "#007BFF",
                            color: "white",
                            borderRadius: "5px",
                            "&:hover": {
                                backgroundColor: "#0056b3",
                            },
                        }}
                    >
                        {discoverLoading ? <CircularProgress size={24} /> : "Discover"}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={captureAndPay}
                        disabled={!deviceDiscovered || loading}
                        sx={{
                            padding: "10px 20px",
                            fontSize: "16px",
                            backgroundColor: "#28a745",
                            color: "white",
                            borderRadius: "5px",
                            "&:hover": {
                                backgroundColor: "#218838",
                            },
                        }}
                    >
                        {loading ? <CircularProgress size={24} /> : "Capture and Pay"}
                    </Button>
                </Stack>
            </Grid>
            <ToastContainer/>
        </Box>
    );
};

export default AadhaarPay;